var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-1 mr-2",attrs:{"x-small":"","fab":"","elevation":"0"}},[_c('v-icon',[_vm._v("mdi-chevron-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }